/* globals google */
'use strict';

const storeFinderUtils = require('./utils');
const isMargiela = document.querySelector('body').classList.contains('Margiela');
const isJilSander = document.querySelector('body').classList.contains('JilSander');
var viewpoint = '';

class StoresMap {
    constructor() {
        this.root = document.documentElement;
        this.HTMLMapTarget = $('.map-canvas');
        this.HTMLResultsTarget = $('.results');
        this.HTMLAutocomplete = document.getElementById('store-postal-code');
        this.HTMLInfoWindow = $('.infowindow-layer');
        this.boundSearchURL = $('.store-locator-fields-row').attr('data-boundsearch');
        this.centerSearchURL = $('.store-locator-fields-row').attr('data-centersearch');
        this.rangeSearchURL = $('.store-locator-fields-row').attr('data-rangesearch');
        this.brandSearchUrl = $('.store-locator-fields-row').attr('data-brandsearch');
        this.countrySearchUrl = $('.store-locator-fields-row').attr('data-countrysearch');
        this.countryStartCoords = $('.store-locator-fields-row').attr('data-countrystartcoords');
        if (typeof google !== 'undefined') {
        this.infowindow = new google.maps.InfoWindow();
        this.bounds = new google.maps.LatLngBounds();
        this.geocoder = new google.maps.Geocoder();
        }
        this.HANDLE_ZOOM = 10;
        this.MARKERS = [];
        this.MAPID = this.HTMLMapTarget.attr('data-google-map-id');
    }

    init() {
        const $canvas = this.HTMLMapTarget;

        if (!$canvas) {
            return;
        }

        const isDetailPage = $canvas.attr('data-detail');
        const mapConfigs = {
            centerLat: !isDetailPage ? $canvas.attr('data-centerlat') * 1 : parseFloat($canvas.attr('data-latitude')),
            centerLng: !isDetailPage ? $canvas.attr('data-centerlng') * 1 : parseFloat($canvas.attr('data-longitude')),
            zoom: !isDetailPage ? $canvas.attr('data-zoom') * 1 : 18,
        };

        this.handleAutocomplete();
        this.handleButtonSearch();
        if (this.MAPID) this.drawMap(mapConfigs);

        if (!isDetailPage) {
            this.drawMarkers();
            if (this.MAPID) this.handleMapEvents();
            this.handleAutocompleteEvents();
            this.layout();
        } else {
            this.drawSingleMarker(mapConfigs);
            this.handlers();
        }

        if(isMargiela) {
          this.handleEnter();
          this.handleButtonEvents();
        }
       
    }

    /**
     * Draw map in storefinder pages
     * @param {Object} configs - { centerLat: <number>, centerLng: <number>, zoom: <number> }
     */
    drawMap(configs) {
        const map = new google.maps.Map(this.HTMLMapTarget[0], {
            scrollwheel: false,
            zoom: configs.zoom,
            center: new google.maps.LatLng(configs.centerLat, configs.centerLng),
            mapTypeControl: false,
            mapId: this.MAPID
        });
        this.setMap = map;
    }

    /**
     * Draw markers in landing page map
     */
    drawMarkers() {
        const $canvas = this.HTMLMapTarget;
        const $container = $('.store-locator-canvas-container');
        const isDetailPage = $canvas.attr('data-detail');
        let results = $canvas.attr('data-locations');

        if (!results) {
            return;
        }

        results = JSON.parse(results);
        var isSingleStore = results.length === 1;
        Object.keys(results).forEach((key, index) => {
            const item = results[key];
            const $map = this.getMap;
            const marker = storeFinderUtils.buildMarker($map, item, $container.hasClass('layout-split') ? index + 1 : ' ', isDetailPage, isSingleStore);
            const infowindow = this.infowindow;
            const $layer = this.HTMLInfoWindow;

            this.MARKERS.push(marker);
            marker.addListener('click', function() {
                const content = $(`[data-store-id="${item.id}"] .info-window-content`).html();

                if (storeFinderUtils.mq()) {

                  if(isMargiela){
                    // console.log('[MARGIELA]');
                    $layer.html(content);
                    const event = new CustomEvent('trigger:showmodal', {
                      detail: {
                        id: 'store-locator-map-pin-modal'
                      }
                    });
                    document.body.dispatchEvent(event);

                  } else {
                    // console.log('[MARNI]');
                    $layer.html(content).addClass('open');
                  }

                    
                } else {
                    $map.panTo({lat: marker.position.lat() + 20, lng: marker.position.lng() }); 
                    infowindow.setOptions({
                        maxWidth: 375,
                        content: content.toString(),
                    });
                    infowindow.open($map, marker);
                }
            });

            if (results.length !== 0) {
                this.bounds.extend(marker.position);
            }
        });

        this.handleTriggerMarkers();
    }

    /**
     * Draw marker in detail page map
     * @param {Object} configs - { centerLat: <number>, centerLng: <number>, zoom: <number> }
     */
    drawSingleMarker(configs) {
        const coords = {
            latitude: configs.centerLat,
            longitude: configs.centerLng,
            isOutlet: this.HTMLMapTarget.attr('data-outlet') === 'true',
        };
        const marker = storeFinderUtils.buildMarker(this.getMap, coords, false, true);
        this.bounds.extend(marker.position);
    }

    /**
     * Clear all markers on map
     */
    clearMarkers() {
        for (let i = 0; i < this.MARKERS.length; i++) {
            this.MARKERS[i].setMap(null);
        }

        this.MARKERS.length = 0;
    }

    /**
     * trigger markers
     */
    handleTriggerMarkers() {
        $('.results-panel').on('click', '.more-info', (e) => {
            e.preventDefault();
            const $this = $(e.currentTarget);
            const index = $this.data('store-index');

            (typeof google !== 'undefined') && google.maps.event.trigger(this.MARKERS[index - 1], 'click');
            $this.parents('.card-body').addClass('active').siblings('.card-body').removeClass('active');
        });
    }

    /**
     * Draw Google suggestions
     */
    handleAutocomplete() {
        const $input = this.HTMLAutocomplete;

        if ($input) {
            this.setAutocomplete = new google.maps.places.Autocomplete($input, {
                types: ['geocode'],
            });
            this.getAutocomplete.setFields(['address_component','geometry']);
        }
    }

    handleEnter () {
      var input= document.getElementById('store-postal-code');
      google.maps.event.addDomListener(input, 'keyup', function(e) {
        if (e.keyCode == 13 && $('.pac-container:visible').length) {
          e.preventDefault();
          document.getElementsByClassName('pac-container')[0].style.display = 'none';
        } else if (e.keyCode !== 13) {
          viewpoint = '';
        }
      }); 
    }

    handleButtonEvents () {
      const map = this.getMap;
      $('.mm-btn-accessibility-search-stores').on('click', function() {
        if(viewpoint !== '') {
          map.fitBounds(viewpoint);
        } else {
          $('#store-search-error').removeClass('d-none');
        }
      })
    }

    filterStoresByBrand() {
        const brand = $('.filter-stores-by-brand.selected').attr('data-brand');
        const landingPage = $('.locator-filters').attr('data-landingpage');
        const map = this.getMap;
        const bounds = storeFinderUtils.getBoundariesCoords(map);
        const { latmin, latmax, lngmin, lngmax } = bounds;
        const payload = { latmin, latmax, lngmin, lngmax, brand, landingPage };
    
        this.clearMarkers();
        $.ajax({
            url: this.brandSearchUrl,
            type: 'get',
            data: payload,
            dataType: 'json',
            success: (data) => {
                this.updateResults(data);
            },
        });
    
        // Tealium event "Search Location"
        $('body').trigger('store:Search');    
        return false;
    }

    filterStoresByCountry() {
        const country = $('.filter-stores-by-country.selected').attr('data-country');
        const landingPage = $('.locator-filters').attr('data-landingpage');
        const payload = { country, landingPage };
    
        $.ajax({
            url: this.countrySearchUrl,
            type: 'get',
            data: payload,
            dataType: 'json',
            success: (data) => {
                this.updateResults(data);
            },
        });
    
        // Tealium event "Search Location"
        $('body').trigger('store:Search');    
        return false;
    }

    /**
     * Search for stores with new zip code
     * @param {Integer} latmin - min latitude
     * @param {Integer} latmax - max latitude
     * @param {Integer} lngmin - min longitude
     * @param {Integer} lngmax - max longitude
     * @returns {boolean} false to prevent default event
     */
    searchStoresByBoundaries(latmin, latmax, lngmin, lngmax, filter) {
        const payload = { latmin, latmax, lngmin, lngmax, filter };

        this.clearMarkers();
        $.ajax({
            url: this.boundSearchURL,
            type: 'get',
            data: payload,
            dataType: 'json',
            success: (data) => {
              if(data.showFilter) { 
                if($('.locator-filters')) {
                  $('.locator-filters').removeClass('-hide');
                  $('.mm-btn-accessibility-search-stores').addClass('mm-btn-accessibility-search-stores-filters');
                  $('.accessibility-search-stores').addClass('accessibility-search-stores-filters');
                  $('.locator-filter-actions-wrapper .detect-location:not(.filter-detect-location)').addClass('-hide');
                } 
              } else if($('.locator-filters')){
                $('.locator-filters').addClass('-hide');
                $('.mm-btn-accessibility-search-stores').removeClass('mm-btn-accessibility-search-stores-filters');
                $('.accessibility-search-stores').removeClass('accessibility-search-stores-filters');
                $('.filter-stores-by-brand').removeClass('selected');
                $('.filter-stores-by-brand.all').addClass('selected');
                $('.locator-filter-actions-wrapper .detect-location:not(.filter-detect-location)').removeClass('-hide');
              }
              this.updateResults(data);
            },
        });

        // Tealium event "Search Location"
        $('body').trigger('store:Search');

        return false;
    }


  searchStoresByCenter(latmin, latmax, lngmin, lngmax, latcenter, lngcenter, filter) {
    const payload = {latmin, latmax, lngmin, lngmax, latcenter, lngcenter, filter };

    this.clearMarkers();
    $.ajax({
        url: this.centerSearchURL,
        type: 'get',
        data: payload,
        dataType: 'json',
        success: (data) => {
          this.updateResults(data);
        },
    });

    // Tealium event "Search Location"
    $('body').trigger('store:Search');

    return false;
}
    /**
     * Renders the results of the search and updates the map
     * @param {Object} data - Response from the server
     */
    updateResults(data) {
        const $canvas = this.HTMLMapTarget;
        const $canvasContainer = $('.store-locator-canvas-container');
        const $results = this.HTMLResultsTarget;
        const $resultPanel = $('.results-panel');
        const $noResults = $('.store-locator-no-results');
        const $resultsLength = $('.results-length');
        const hasResults = data.stores.stores.length > 0;
        const $panel = $('.store-locator-fields-layer .fields-box');
        const $buttonSearch = $('.btn-storelocator-search');
        const $smTarget = $('[data-sm-results]');

        $canvasContainer.addClass('layout-split');
        $buttonSearch.removeAttr('disabled');
        $canvas.attr('data-locations', data.stores.locations);
        $results.empty().attr('data-has-results', hasResults);

        if (storeFinderUtils.mq() && !isMargiela) {
            $resultPanel.appendTo($smTarget);
            $smTarget.removeAttr('hidden');
        }

        // update length label
        const $lengthTarget = $resultsLength.find('.results-length-target');
        $lengthTarget.html(data.stores.stores.length);

        // update map padding left
        if ($panel.length) {
          const panelWidth = $panel.width();
          const panelOffset = $panel.offset().left;
          this.root.style.setProperty('--padding-left', `${panelWidth + panelOffset}px`);
          this.drawMarkers();
        }

        $('.store-locator-result-area').removeClass('d-none');
        // $('.page-storelocator-landing').addClass('-stores-result-wrapper');
        $('.page--storefinder-landing').addClass('-stores-result-wrapper');
        if (hasResults) {
            $resultsLength.removeClass('d-none');
            $results.append(data.stores.storesResultsHtml).removeAttr('hidden');
            $noResults.attr('hidden', 'hidden');
        } else {
            $results.attr('hidden', 'hidden');
            $noResults.removeAttr('hidden');
            $resultsLength.addClass('d-none');
        }

        if (isJilSander) {
          const $country = $results.find('[data-country]');
          const country = $country.length > 0;
          $('.page-storelocator-landing')[country ? 'addClass' : 'removeClass']('country');
          if (country) {
            $('.store-country').text($country.attr('data-country-name'));
          }
          const $parent = $lengthTarget.parent();
          const $contents = $parent.contents();
          $contents[$contents.length - 1].nodeValue = country ? $country.attr('data-country-results') : $parent.attr('data-text');
      }
    }

    /**
     * Listen to zoom|dragend and update stores data
     */
    handleMapEvents() {
        const self = this;
        const map = this.getMap;

        const refresh = () => {
            const bounds = storeFinderUtils.getBoundariesCoords(map);
            const { latmin, latmax, lngmin, lngmax } = bounds;
            if($('.locator-filters')) {
              $('.locator-filters').attr('data-landingpage', false);
            } 
            const filter = $('.filter-stores-by-brand.selected').attr('data-brand');
            self.searchStoresByBoundaries(latmin, latmax, lngmin, lngmax, filter);
            
        };

        map.addListener('dragend', function() {
            refresh();
        });

        map.addListener('zoom_changed', function() {
            refresh();
        });
    }

    /**
     * Listen to address input event
     */
    handleButtonSearch() {
        const $input = $('#store-postal-code');
        const $button = $('.btn-storelocator-search');

        $input.on('input', (e) => {
            const $this = $(e.currentTarget);

            return $this.val().length > 0 ? $button.removeAttr('disabled') : $button.attr('disabled', true);
        });
    }

    /**
     * Listen to address input event
     */
    handleAutocompleteEvents() {
        const map = this.getMap;
        const autocomplete = this.getAutocomplete;

        autocomplete.addListener('place_changed', () => {
            const res = autocomplete.getPlace();
            if (map) {
              if(isMargiela) {
                if((typeof res.geometry === 'undefined')) {
                  $('#store-search-error').removeClass('d-none');
                  viewpoint = '';
                } else {
                  $('#store-search-error').addClass('d-none');
                  viewpoint = res.geometry.viewport;
                }          
              } else {
                if(res.address_components.length > 0 && res.address_components[0].types[0] === "country" && this.countryStartCoords.length > 0 && JSON.parse(this.countryStartCoords)[res.address_components[0].short_name] ) {

                  const bounds = res.geometry.viewport;
                  const latLng1 = bounds.getSouthWest();
                  const latLng2 = bounds.getNorthEast();

                  const newBounds = new google.maps.LatLngBounds(latLng1, latLng2);
                  const latcenter =  newBounds.getCenter().lat();
                  const lngcenter = newBounds.getCenter().lng();

                  const currentCountry = res.address_components[0].short_name; 
                  const newZoom = JSON.parse(this.countryStartCoords)[currentCountry][3];
                
                  map.setCenter({lat: JSON.parse(this.countryStartCoords)[currentCountry][0], lng: JSON.parse(this.countryStartCoords)[currentCountry][1]})
                  map.setZoom(newZoom); 
      
                } else {
              map.fitBounds(res.geometry.viewport);
                }
               
              }
      
            } else {
              const bounds = res.geometry.viewport;
              const latLng1 = bounds.getSouthWest();
              const latLng2 = bounds.getNorthEast();
              const latmin = Math.min(latLng1.lat(), latLng2.lat());
              const lngmin = Math.min(latLng1.lng(), latLng2.lng());
              const latmax = Math.max(latLng1.lat(), latLng2.lat());
              const lngmax = Math.max(latLng1.lng(), latLng2.lng());

              if(isJilSander) {
                const newBounds = new google.maps.LatLngBounds(latLng1, latLng2);
                const latcenter =  newBounds.getCenter().lat();
                const lngcenter = newBounds.getCenter().lng();

                this.searchStoresByCenter(latmin, latmax, lngmin, lngmax, latcenter, lngcenter, null);
  
              } else {
              this.searchStoresByBoundaries(latmin, latmax, lngmin, lngmax, null);
              }
            }
        });
    }

    /**
     * Listen to button search event
     */
    handleSearchEvents() {
        const map = this.getMap;

        if (this.HTMLAutocomplete) {
            this.geocoder.geocode({ address: this.HTMLAutocomplete.value }, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK) {
                    map.fitBounds(results[0].geometry.viewport);
                }
            });
        }
    }

    /**
     * Search for stores with new zip code
     * @param {HTMLElement} $elem - HTML DOM button
     */
    geoLocation($elem) {
        const self = this;
        const map = this.getMap;
        navigator.geolocation.getCurrentPosition(
            (position) => {
                map.setCenter({ lat: position.coords.latitude, lng: position.coords.longitude });
                map.setZoom(this.HANDLE_ZOOM);
                const bounds = storeFinderUtils.getBoundariesCoords(map);
                const { latmin, latmax, lngmin, lngmax } = bounds;
                const filter = $('.filter-stores-by-brand.selected').attr('data-brand');
                self.searchStoresByBoundaries(latmin, latmax, lngmin, lngmax, filter);
                $('.store-locator-fields-layer .form-control').val('');

                // update serch box title with street name
                const location = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };

                this.geocoder.geocode({ location }, function(results, status) {
                    if (status === 'OK' && results[0]) {
                        const str = `${results[0].address_components[1].long_name} (${results[0].address_components[4].short_name})`;

                        if (storeFinderUtils.mq()) {
                            $('.store-locator-fields-layer .form-control').val(str);
                        } else {
                            $('.fields-header-group .title-fields').text(str);
                        }
                    }
                });
            },
            () => {
                $elem.attr('disabled', true);
            }
        );
    }

    /**
     * Global layout events
     */
    layout() {
        const $panel = $('.store-locator-fields-layer .fields-box');
        const $mapWrapper = $('.store-locator-canvas-container');
        const $layer = this.HTMLInfoWindow;

        $(window).on('resize', () => {
            if ($mapWrapper.hasClass('layout-split')) {
                const panelWidth = $panel.width();
                const panelOffset = $panel.offset().left;
                this.root.style.setProperty('--padding-left', `${panelWidth + panelOffset}px`);
            }
        });

        $(document).on('click', '.hero-infowindow-close', () => {
            $layer.removeClass('open');
        });
    }

    /**
     * Handlers for detail page
     */
    handlers() {
        $('.handlers-row').on('click', '.cell', (e) => {
            const $this = $(e.currentTarget);
            const target = $this.attr('data-target');

            $('html, body').animate({
                    scrollTop: $(`#${target}`).offset().top,
                },
                300
            );
        });
    }

    set setMap(m) {
        this.map = m;
    }

    get getMap() {
        return this.map;
    }

    set setAutocomplete(a) {
        this.autocomplete = a;
    }

    get getAutocomplete() {
        return this.autocomplete;
    }
}

const storesMap = new StoresMap();
module.exports = storesMap;
